import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
    export class ToastSeverity {
        constructor(private messageService: MessageService) {}
    
        showSuccess(detail = '') {
            this.messageService.add({ severity: 'success', summary: 'Успешно', detail: detail});
        }
    
        showError(detail = '') {
            this.messageService.add({ severity: 'error', summary: 'Ошибка', detail: detail });
        }
    }
    